import { BaseNavigationBar } from "@/lib/components/navigation";
import { useIsMobile } from "@/lib/hooks/use-mobile";
import { useNotifications } from "../../hooks";
import { NotificationActionsDesktop } from "../actions/notification-actions-desktop";
import { NotificationActionsMobile, ReadAllButton } from "../actions/notification-actions-mobile";

export function NotificationListHeader() {
  const isMobile = useIsMobile();

  // Main hook
  const { notifications, loading, error, refetch, markAsRead } = useNotifications();

  const handleMarkAsRead = async (ids: string[], markAll = false) => {
    await markAsRead(ids, markAll);
  };

  // Mobile leading elements (Read All button)
  const mobileLeadingElement = (
    <ReadAllButton transformedNotifications={notifications} onMarkAsRead={handleMarkAsRead} />
  );

  // Mobile trailing elements (compact actions)
  const mobileTrailingElements = [
    <NotificationActionsMobile
      key="mobile-actions"
      transformedNotifications={notifications}
      loading={loading}
      error={error}
      onMarkAsRead={handleMarkAsRead}
      onRefetch={refetch}
    />,
  ];

  // Desktop trailing elements (full toolbar)
  const desktopTrailingElements = [
    <NotificationActionsDesktop
      key="desktop-actions"
      transformedNotifications={notifications}
      loading={loading}
      error={error}
      onMarkAsRead={handleMarkAsRead}
      onRefetch={refetch}
    />,
  ];

  return (
    <BaseNavigationBar
      title="Notifications"
      subtitle="Stay updated with important salon activities and updates"
      leadElement={isMobile ? mobileLeadingElement : undefined}
      trailingElements={isMobile ? mobileTrailingElements : desktopTrailingElements}
    />
  );
}
